import { render, staticRenderFns } from "./yiCiDuoYi.vue?vue&type=template&id=29ba1d35&scoped=true&"
import script from "./yiCiDuoYi.vue?vue&type=script&lang=js&"
export * from "./yiCiDuoYi.vue?vue&type=script&lang=js&"
import style0 from "./yiCiDuoYi.vue?vue&type=style&index=0&id=29ba1d35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ba1d35",
  null
  
)

export default component.exports